import { createSlice } from "@reduxjs/toolkit";

export const spinnerSlice = createSlice({
    name: 'spinner',
    initialState: {
        _switch: false
    },
    reducers: {
        showSpinner: (state, { payload }) => {
            state._switch = payload;
        }
    }
})
  
export const { showSpinner } = spinnerSlice.actions;
export default spinnerSlice.reducer;